<ng-reservations
  *ngIf="(store$ | async) as store"
  [loading]="store.state.loading"
  [reservations]="store.state.reservations"
  [name]="name"
  [title]="title"
  [printTitle]="printTitle"
  (reload)="dispatchLoadReservations()">
</ng-reservations>
